import { ShortCode } from '@highereducation/wordpress';
import { Text, TextProps } from '@highereducation/hen-ui';

interface TextShortcodeProps extends Omit<TextProps, 'children'> {
  variant?: 'd1' | 'd2' | 'd3' | 'b1' | 'b2' | 'b3' | 'b4' | 'b5' | 'l1' | 'l2';
  color?: 'default' | 'heading' | 'white' | 'subtext';
  align?: 'left' | 'center' | 'right';
  weight?: 'light' | 'regular' | 'medium' | 'semibold' | 'bold';
  tag?:
    | 'p'
    | 'span'
    | 'strong'
    | 'em'
    | 'small'
    | 'b'
    | 'i'
    | 'sub'
    | 'sup'
    | 'ins'
    | 'del'
    | 'mark';
  children?: React.ReactNode;
  [key: string]: unknown;
}

/**
 * TextShortcode - Shortcode wrapper for Text atomic component
 *
 * Supported shortcode attributes:
 * - variant: 'd1' | 'd2' | 'd3' | 'b1' | 'b2' | 'b3' | 'b4' | 'b5' | 'l1' | 'l2' (default: 'b4') - Text style
 * - color: 'default' | 'heading' | 'white' (default: 'default') - Text color
 * - align: 'left' | 'center' | 'right' - Text alignment
 * - weight: 'light' | 'regular' | 'medium' | 'semibold' | 'bold' (default: 'regular') - Font weight
 * - tag: HTML tag to render (default: 'p') - Semantic HTML element
 * - id: DOM id for in-page jump targets (e.g. citation anchors)
 *
 * @example WordPress shortcode usage:
 * [hen-ui-text variant="b3"]Body text[/hen-ui-text]
 * [hen-ui-text variant="b3" color="white"]White body text[/hen-ui-text]
 * [hen-ui-text variant="b3" align="center"]Centered text[/hen-ui-text]
 * [hen-ui-text tag="span" id="source-1"]Citation target[/hen-ui-text]
 */
export const TextShortcode: ShortCode<TextShortcodeProps> = {
  balanced: true,
  component: ({
    variant = 'b4',
    color,
    align,
    weight,
    tag = 'p',
    id,
    children,
  }) => {
    return (
      <Text
        variant={variant}
        color={color}
        align={align}
        weight={weight}
        tag={tag}
        id={id}
      >
        {children}
      </Text>
    );
  },
};
